import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import "react";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function EmptySearchImage_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else EmptySearchImage_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const EmptySearchImage = (t0)=>{
    const $ = c(23);
    let props;
    if ($[0] !== t0) {
        props = _extends({}, t0);
        $[0] = t0;
        $[1] = props;
    } else props = $[1];
    let t1;
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    let t19;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M84.3523 86.5519C90.4899 53.1456 122.547 31.0399 155.953 37.1775L216.438 48.2902C249.845 54.4279 271.95 86.4846 265.813 119.891C259.675 153.297 227.619 175.403 194.212 169.265L133.727 158.153C100.32 152.015 78.2147 119.958 84.3523 86.5519Z",
            fill: "#EDF3FF"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M109.423 80.2197C108.675 75.3726 112.425 70.9999 117.329 70.9999H239.737C244.619 70.9999 248.363 75.3346 247.652 80.1646L238.486 142.456C237.764 147.363 233.553 151 228.593 151H128.918C123.984 151 119.788 147.401 119.035 142.525L109.423 80.2197Z",
            fill: "#EDF3FF"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M239.737 70.9999C244.619 70.9999 248.363 75.3346 247.652 80.1646L238.486 142.456L238.408 142.912C237.5 147.587 233.398 151 228.593 151L228.592 150C233.057 150 236.847 146.727 237.497 142.31L246.663 80.0194C247.285 75.7933 244.009 71.9999 239.737 71.9999H117.33C113.038 71.9999 109.757 75.8261 110.412 80.0673L120.023 142.372C120.7 146.761 124.478 150 128.919 150L128.918 151L128.458 150.989C123.725 150.773 119.764 147.249 119.035 142.525L109.423 80.2197C108.699 75.5239 112.195 71.2734 116.874 71.0126L117.329 70.9999H239.737ZM228.592 150L228.593 151H128.918L128.919 150H228.592Z",
            fill: "#99BCFF"
        });
        t4 = /*#__PURE__*/ jsx("path", {
            d: "M208.001 107V105C208.001 103.895 207.105 103 206.001 103H182.001C180.896 103 180.001 103.895 180.001 105V107C180.001 108.104 180.896 109 182.001 109L206.001 109C207.105 109 208.001 108.104 208.001 107Z",
            fill: "#D8E5FF"
        });
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M207.501 105C207.501 104.171 206.829 103.5 206.001 103.5H182.001C181.172 103.5 180.501 104.171 180.501 105V107C180.501 107.828 181.172 108.5 182.001 108.5H206.001C206.829 108.5 207.501 107.828 207.501 107V105ZM208.501 107C208.501 108.381 207.381 109.5 206.001 109.5H182.001C180.62 109.5 179.501 108.381 179.501 107V105C179.501 103.619 180.62 102.5 182.001 102.5H206.001C207.381 102.5 208.501 103.619 208.501 105V107Z",
            fill: "#99BCFF"
        });
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M218.001 118V116C218.001 114.895 217.105 114 216.001 114H178.001C176.896 114 176.001 114.895 176.001 116V118C176.001 119.104 176.896 120 178.001 120L216.001 120C217.105 120 218.001 119.104 218.001 118Z",
            fill: "#D8E5FF"
        });
        t7 = /*#__PURE__*/ jsx("path", {
            d: "M217.501 116C217.501 115.171 216.829 114.5 216.001 114.5H178.001C177.172 114.5 176.501 115.171 176.501 116V118C176.501 118.828 177.172 119.5 178.001 119.5H216.001C216.829 119.5 217.501 118.828 217.501 118V116ZM218.501 118C218.501 119.381 217.381 120.5 216.001 120.5H178.001C176.62 120.5 175.501 119.381 175.501 118V116C175.501 114.619 176.62 113.5 178.001 113.5H216.001C217.381 113.5 218.501 114.619 218.501 116V118Z",
            fill: "#99BCFF"
        });
        t8 = /*#__PURE__*/ jsx("path", {
            d: "M240.001 66.9999H125.001C125.001 63.1176 125.001 54.7058 132.922 54.7058H192.379C192.379 50.8895 192.427 44.9999 198.803 44.9999H236.422C239.769 44.9999 242.001 48.8162 242.001 52.6326V64.9999C242.001 66.1045 241.105 66.9999 240.001 66.9999Z",
            fill: "#D8E5FF"
        });
        t9 = /*#__PURE__*/ jsx("path", {
            d: "M241.501 52.6327C241.501 50.8144 240.967 49.0066 240.053 47.6669C239.141 46.3297 237.884 45.4999 236.422 45.4999H198.803C197.288 45.4999 196.192 45.8489 195.39 46.3935C194.588 46.9384 194.038 47.7065 193.662 48.6132C192.898 50.4545 192.879 52.7773 192.879 54.706V55.206H132.922C131.036 55.206 129.661 55.7047 128.646 56.4784C127.626 57.2561 126.93 58.3419 126.458 59.5761C125.584 61.8604 125.508 64.5595 125.502 66.4999H240.001C240.829 66.4999 241.501 65.8283 241.501 64.9999V52.6327ZM242.501 64.9999C242.501 66.3806 241.381 67.4999 240.001 67.4999H124.501V66.9999C124.501 65.0737 124.496 61.907 125.524 59.2187C126.042 57.8647 126.832 56.6043 128.04 55.6835C129.253 54.7588 130.848 54.206 132.922 54.206H191.88C191.886 52.3871 191.958 50.1111 192.738 48.2304C193.171 47.1877 193.829 46.2449 194.829 45.5663C195.829 44.8874 197.131 44.4999 198.803 44.4999H236.422C238.306 44.4999 239.839 45.5784 240.88 47.1034C241.918 48.626 242.501 50.6347 242.501 52.6327V64.9999Z",
            fill: "#99BCFF"
        });
        t10 = /*#__PURE__*/ jsx("path", {
            d: "M184.001 92.4999C184.001 112.106 168.107 128 148.501 128C128.894 128 113.001 112.106 113.001 92.4999C113.001 72.8938 128.894 56.9999 148.501 56.9999C168.107 56.9999 184.001 72.8938 184.001 92.4999Z",
            fill: "#D8E5FF"
        });
        t11 = /*#__PURE__*/ jsx("path", {
            d: "M184.001 101V90.9999H142.001C140.896 90.9999 140.001 91.8953 140.001 92.9999V98.9999C140.001 100.104 140.896 101 142.001 101L184.001 101Z",
            fill: "#B8CEFA"
        });
        t12 = /*#__PURE__*/ jsx("path", {
            d: "M184.001 90.4999C184.277 90.4999 184.501 90.7238 184.501 90.9999V101C184.501 101.276 184.277 101.5 184.001 101.5H142.001C140.62 101.5 139.501 100.381 139.501 98.9999V92.9999C139.501 91.6192 140.62 90.4999 142.001 90.4999H184.001ZM140.501 98.9999C140.501 99.8283 141.172 100.5 142.001 100.5H183.501V91.4999H142.001C141.172 91.4999 140.501 92.1715 140.501 92.9999V98.9999Z",
            fill: "#99BCFF"
        });
        t13 = /*#__PURE__*/ jsx("path", {
            d: "M181.001 115V105H150.001C148.896 105 148.001 105.895 148.001 107V113C148.001 114.104 148.896 115 150.001 115L181.001 115Z",
            fill: "#B8CEFA"
        });
        t14 = /*#__PURE__*/ jsx("path", {
            d: "M181.001 104.5C181.277 104.5 181.501 104.724 181.501 105V115C181.501 115.276 181.277 115.5 181.001 115.5H150.001C148.62 115.5 147.501 114.381 147.501 113V107C147.501 105.619 148.62 104.5 150.001 104.5H181.001ZM148.501 113C148.501 113.828 149.172 114.5 150.001 114.5H180.501V105.5H150.001C149.172 105.5 148.501 106.171 148.501 107V113Z",
            fill: "#99BCFF"
        });
        t15 = /*#__PURE__*/ jsx("path", {
            d: "M115.001 119L93.6366 141.893C87.2728 148.333 93.6366 154.772 100 148.333L122.001 126C120.001 124.5 117.001 121.5 115.001 119Z",
            fill: "#D8E5FF"
        });
        t16 = /*#__PURE__*/ jsx("path", {
            d: "M115.019 118.5C115.164 118.505 115.301 118.574 115.391 118.687C117.372 121.163 120.342 124.131 122.3 125.6C122.416 125.686 122.489 125.819 122.5 125.963C122.51 126.106 122.458 126.248 122.357 126.35L100.356 148.683C97.0807 151.998 93.5653 152.191 91.6901 150.294C89.8211 148.403 90.0051 144.856 93.2809 141.542L114.635 118.659L114.716 118.589C114.804 118.528 114.91 118.496 115.019 118.5ZM94.0026 142.234C93.9993 142.238 93.9952 142.242 93.9918 142.245C90.9042 145.369 91.0884 148.262 92.401 149.591C93.7076 150.913 96.5561 151.106 99.6442 147.981L121.25 126.05C119.359 124.54 116.828 122.001 114.974 119.759L94.0026 142.234Z",
            fill: "#99BCFF"
        });
        t17 = /*#__PURE__*/ jsx("path", {
            d: "M133.202 71.1069C128.691 74.7009 121.001 76.9999 121.001 76.9999C121.001 76.9999 125.046 69.7377 129.001 66.4999C133.62 62.7175 143.001 59.9999 143.001 59.9999C143.001 59.9999 137.48 67.699 133.202 71.1069Z",
            fill: "white"
        });
        t18 = /*#__PURE__*/ jsx("path", {
            d: "M192.001 92.4999C192.001 116.524 172.525 136 148.501 136C124.476 136 105.001 116.524 105.001 92.4999C105.001 68.4755 124.476 48.9999 148.501 48.9999C172.525 48.9999 192.001 68.4755 192.001 92.4999ZM113.66 92.4999C113.66 111.742 129.259 127.34 148.501 127.34C167.742 127.34 183.341 111.742 183.341 92.4999C183.341 73.258 167.742 57.6594 148.501 57.6594C129.259 57.6594 113.66 73.258 113.66 92.4999Z",
            fill: "#D8E5FF"
        });
        t19 = /*#__PURE__*/ jsx("path", {
            d: "M191.001 92.4999C191.001 69.0278 171.973 49.9999 148.501 49.9999C125.028 49.9999 106.001 69.0278 106.001 92.4999C106.001 115.972 125.028 135 148.501 135V136C124.476 136 105.001 116.524 105.001 92.4999C105.001 68.4755 124.476 48.9999 148.501 48.9999C172.525 48.9999 192.001 68.4755 192.001 92.4999C192.001 116.524 172.525 136 148.501 136V135C171.973 135 191.001 115.972 191.001 92.4999ZM183.341 92.4999C183.341 73.258 167.742 57.6594 148.501 57.6594C129.259 57.6594 113.66 73.258 113.66 92.4999C113.66 111.441 128.775 126.852 147.601 127.329L148.501 127.34C167.442 127.34 182.853 112.226 183.33 93.3993L183.341 92.4999ZM184.341 92.4999C184.341 112.294 168.295 128.341 148.501 128.341C128.706 128.341 112.66 112.294 112.66 92.4999C112.66 72.7058 128.706 56.6591 148.501 56.6591C168.295 56.6591 184.341 72.7058 184.341 92.4999Z",
            fill: "#99BCFF"
        });
        $[2] = t1;
        $[3] = t10;
        $[4] = t11;
        $[5] = t12;
        $[6] = t13;
        $[7] = t14;
        $[8] = t15;
        $[9] = t16;
        $[10] = t17;
        $[11] = t18;
        $[12] = t19;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
    } else {
        t1 = $[2];
        t10 = $[3];
        t11 = $[4];
        t12 = $[5];
        t13 = $[6];
        t14 = $[7];
        t15 = $[8];
        t16 = $[9];
        t17 = $[10];
        t18 = $[11];
        t19 = $[12];
        t2 = $[13];
        t3 = $[14];
        t4 = $[15];
        t5 = $[16];
        t6 = $[17];
        t7 = $[18];
        t8 = $[19];
        t9 = $[20];
    }
    let t20;
    if ($[21] !== props) {
        t20 = /*#__PURE__*/ jsxs("svg", _object_spread_props(_object_spread({
            width: "340",
            height: "200",
            viewBox: "0 0 340 200",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, props), {
            children: [
                t1,
                t2,
                t3,
                t4,
                t5,
                t6,
                t7,
                t8,
                t9,
                t10,
                t11,
                t12,
                t13,
                t14,
                t15,
                t16,
                t17,
                t18,
                t19
            ]
        }));
        $[21] = props;
        $[22] = t20;
    } else t20 = $[22];
    return t20;
};
export { EmptySearchImage };
